import React from "react";
import { LegacyCard as Card, SkeletonBodyText, SkeletonDisplayText, BlockStack } from "@shopify/polaris";

const SkeletonCard = () => {
  return (
    <Card sectioned>
      <BlockStack gap="400">
        <SkeletonDisplayText size="small" />
        <SkeletonBodyText />
      </BlockStack>
    </Card>
  );
};

export default SkeletonCard;
